// @ts-nocheck
/* eslint-enable */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import styled from 'styled-components';
import { padding, stacked } from 'app/shared/styles/_spacing';
import { textOverflow } from 'app/shared/styles/_mixins';

import {
  fdpFloorplansStyles,
  headerContStyles,
  headerStyles,
  summaryStyles,
  summaryTopStyles,
  summaryBottomStyles,
  summaryPriceStyles,
  summarySqftStyles,
  imgDetailsContStyles,
  imgContStyles,
  detailsContStyles,
  tableContainerStyles,
  noticeWrapperStyles,
  labelHeaderStyles,
  labelHeaderStyles3Col,
  unitStyles,
  unitStyles3Col,
  unitEmptyStyles,
  badgeColumnStyles,
  labelPriceStyles,
  unitPriceStyles,
  labelAvailabilityStyles,
  unitAvailabilityStyles,
  labelNameStyles,
  unitNameStyles,
  unitPriceEmptyStyles,
  unitAvailabilityEmptyStyles,
  unitNameEmptyStyles,
} from './FdpFloorplans.styles';
import CallLinkV2 from 'app/shared/modules/hdp/CallLinkV2';
import controller from './controller';
import formatter from 'app/shared/utils/formatter';
import Linker from 'app/shared/modules/Linker';
import Title from 'app/shared/modules/Title';
import TotalMonthlyPriceBadge from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceBadge';
import TotalMonthlyPriceNotice from 'app/shared/modules/TotalMonthlyPrice/TotalMonthlyPriceNotice';
import { shouldShowTotalMonthlyPriceBadge } from 'app/shared/utils/totalMonthlyPriceUtils';
import NewUnitBadge from 'app/shared/modules/hdp/NewUnitBadge';
import PriceDropBadge from 'app/shared/modules/hdp/PriceDropBadge';
import {
  priceWithDropStyles,
  currentPriceStyles,
  previousPriceStyles,
} from 'app/shared/modules/hdp/PriceDropBadge/PriceDropBadge.styles';
import experimentConstants from 'app/shared/constants/ExperimentConstants';

const StyledTitle = styled(Title)`
  ${stacked._xs};
`;
const StyledDiv = styled.div`
  ${padding.top._4x};
`;
const TextOverflowDiv = styled.div`
  ${textOverflow};
`;
class FdpFloorplans extends Component {
  static propTypes = {
    active: PropTypes.bool,
    floorplan: PropTypes.object.isRequired,
    listing: PropTypes.object.isRequired,
    onHideModal: PropTypes.func.isRequired,
    waitlisted: PropTypes.bool,
  };

  static defaultProps = {
    active: true,
    waitlisted: false,
  };

  renderNoUnitsRow = (hasBadges) => {
    return (
      <div className={`${hasBadges ? unitStyles : unitStyles3Col} ${unitEmptyStyles}`}>
        {hasBadges && <div className={badgeColumnStyles}></div>}
        <div className={`${unitPriceStyles} ${unitPriceEmptyStyles}`}>No data</div>
        <div className={`${unitAvailabilityStyles} ${unitAvailabilityEmptyStyles}`}>No data</div>
        <div className={`${unitNameStyles} ${unitNameEmptyStyles}`}>No data</div>
      </div>
    );
  };

  renderUnitDetailRow = ({ unit, i, hasBadges }) => {
    const { listing, active, waitlisted, isNewUnitsControl, isPriceDropControl } = this.props;
    let priceText = controller.getPriceSummaryDisplay({ unit });
    if (isEmpty(priceText)) {
      priceText = <CallLinkV2 listing={listing} />;
    }

    // Handle price drop display
    const showPriceDrop = !isPriceDropControl && unit?.hasPriceDropped;
    let priceDisplay = priceText;

    if (showPriceDrop) {
      const { currentPrice, previousPrice } = controller.getPriceDropDisplay({ unit });
      priceDisplay = (
        <div className={priceWithDropStyles}>
          <div className={currentPriceStyles}>
            {currentPrice}
            <PriceDropBadge
              variant="hdp"
              showTooltip={true}
              tooltipContent={unit?.priceDrop ? `$${unit.priceDrop} price drop` : 'Price drop'}
            />
          </div>
          {previousPrice && <div className={previousPriceStyles}>{previousPrice}</div>}
        </div>
      );
    }

    return (
      <div className={hasBadges ? unitStyles : unitStyles3Col} key={`floor-plan-unit-${i}`}>
        {hasBadges && (
          <div className={badgeColumnStyles}>
            {/* Only show New Unit badge when no price drop is showing */}
            {!showPriceDrop && !isNewUnitsControl && unit?.isNewUnit && (
              <NewUnitBadge
                text="New unit"
                variant="hdp"
                showTooltip={true}
                tooltipContent={unit?.createdAgo ? `Added ${unit.createdAgo}` : 'Recently added'}
              />
            )}
          </div>
        )}
        <div className={unitPriceStyles}>{priceDisplay}</div>
        <TextOverflowDiv className={unitAvailabilityStyles}>
          {controller.getAvailabilityDisplay({ active, unit, waitlisted })}
        </TextOverflowDiv>
        <TextOverflowDiv className={unitNameStyles}>
          {formatter.string.upperFirstLowerRest(unit.name || '')}
        </TextOverflowDiv>
      </div>
    );
  };

  render() {
    const { floorplan, onHideModal, isMobile, listing, isNewUnitsControl, isPriceDropControl } = this.props;
    const { topDisplay, bottomDisplay, imgUrl, imgStyle, units } = controller.getFloorplanDetails(floorplan);

    // Smart detection for badges to determine layout
    // Only new units show in badge column now (price drops are in price column)
    const hasNewUnits =
      !isNewUnitsControl &&
      Array.isArray(units) &&
      units.some((unit) => {
        const unitShowsPriceDrop = !isPriceDropControl && unit.hasPriceDropped;
        return !unitShowsPriceDrop && unit.isNewUnit;
      });
    const hasBadges = hasNewUnits;

    return (
      <div className={fdpFloorplansStyles}>
        <div className={headerContStyles}>
          <Title className={headerStyles} size="xl">
            Floor plans
          </Title>
          <div className={summaryStyles}>
            <div className={summaryTopStyles}>{topDisplay}</div>
            <div className={summaryBottomStyles}>
              <div className={summaryPriceStyles}>
                <span>{bottomDisplay.price}</span>
                <TotalMonthlyPriceBadge
                  listing={listing}
                  floorplanId={
                    floorplan?.modelId && typeof floorplan.modelId === 'string' ? floorplan.modelId : undefined
                  }
                />
              </div>
              <div className={summarySqftStyles}>{bottomDisplay.sqft}</div>
            </div>
          </div>
        </div>
        <div className={imgDetailsContStyles}>
          <div className={imgContStyles} style={isMobile ? imgStyle : {}}>
            <img src={imgUrl} alt="" />
          </div>
          <div className={detailsContStyles}>
            <StyledTitle size="md">Available units</StyledTitle>
            <div className={tableContainerStyles}>
              <div className={noticeWrapperStyles}>
                <TotalMonthlyPriceNotice listing={listing} />
              </div>
              <div className={hasBadges ? labelHeaderStyles : labelHeaderStyles3Col}>
                {hasBadges && <div className={badgeColumnStyles}></div>}
                <div className={labelPriceStyles}>
                  {shouldShowTotalMonthlyPriceBadge(listing) && listing.hasTotalMonthlyPrice ? 'Total price' : 'Price'}
                </div>
                <div className={labelAvailabilityStyles}>Available</div>
                <div className={labelNameStyles}>Unit</div>
              </div>
              {isEmpty(units)
                ? this.renderNoUnitsRow(hasBadges)
                : units.map((unit, i) => this.renderUnitDetailRow({ unit, i, hasBadges }))}
              {isEmpty(units) && (
                <StyledDiv>
                  Browse{' '}
                  <Linker onClick={onHideModal} linkType="underline" tabIndex="0">
                    other floor plans
                  </Linker>
                  .
                </StyledDiv>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const newUnitsExperiment = state?.analytics?.runningExperiments?.[experimentConstants.HOTPADS_WEB_NEW_UNITS] || {};
  const isNewUnitsControl = newUnitsExperiment?.isControl !== false; // Default to control if no experiment

  const priceDropExperiment = state?.analytics?.runningExperiments?.[experimentConstants.HOTPADS_WEB_PRICE_DROPS] || {};
  const isPriceDropControl = priceDropExperiment?.isControl !== false; // Default to control if no experiment

  return {
    isMobile: state.app.device.screenWidth === 'sm' || state.app.device.screenWidth === 'xs',
    listing: state?.currentListingDetails?.currentListing,
    isNewUnitsControl,
    isPriceDropControl,
  };
};

export default connect(mapStateToProps)(FdpFloorplans);
